import React from 'react';
import './Services.css';
import Image1 from '../../assets/service-1.svg';
import Image2 from '../../assets/service-2.svg';
import Image3 from '../../assets/service-3.svg';
import useScrollReveal from '../../hooks/useScrollReveal';

const data = [
    {
        id: 1,
        image: Image1,
        title: "Responsive Design",
        description: "Ensuring websites and mobile apps look and feel great across all devices and screen sizes.",
    },
    {
        id: 2,
        image: Image2,
        title: "Web Development",
        description: "Building performant, standards-compliant websites that are easy to maintain and scale.",
    },
    {
        id: 3,
        image: Image3,
        title: "Mobile Development",
        description: "Crafting polished mobile applications that meet quality standards and delight users.",
    },
];

const Services = () => {
    const containerRef = useScrollReveal(0.08);

    return (
        <section className="services container section" id="services">
            <h2 className="section__title">Services</h2>

            <div ref={containerRef} className="services__container grid reveal stagger-children">
                {data.map(({ id, image, title, description }) => (
                    <div className="services__card" key={id}>
                        <div className="services__card-glow" />
                        <img src={image} alt="" className="services__img" width="80" />
                        <h3 className="services__title">{title}</h3>
                        <p className="services__description">{description}</p>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Services;
